import { render } from "./BusinessList.vue?vue&type=template&id=db5ca4e2"
import script from "./BusinessList.vue?vue&type=script&lang=js"
export * from "./BusinessList.vue?vue&type=script&lang=js"
script.render = render

export default script